<template>
  <div class="odontogram-history-entry" >
    <div class="odontogram-history-entry__info" @click="$emit('edit', history)">
      <div class="odontogram-history-entry__date">
        {{ date }} - {{ clinic_name }}
      </div>
      {{ doctor }}
    </div>
    <div class="odontogram-history-entry__summary" @click="$emit('edit', history)" >
      <strong v-if="history.is_public">PUBLICA: </strong>
      {{ summary }}<br>Tratamientos: {{ treatments_summary }}</div>
    <div v-if="is_core" class="odontogram-history-entry__documents d-flex align-items-center justify-content-end">
      <a :href="`/customer/${history.customer_id}/document/${document.id}/view`" target="_blank"
        v-for="document in history.documents" :key="document.id" class="odontogram-history-entry__document text-center">
        <i class="fas fa-file mt-2">
        </i>
        <br>
        <small>{{ document.title }}</small>
      </a>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  props: {
    history: { required: true },
    clinics: { required: true },
  },
  computed: {
    clinic_name() {
      let name = this.clinics[this.history.clinic_id] || null;
      return name ? name : "";
    },
    date() {
      return moment(this.history.created_at).format("DD/MM/YYYY");
    },
    doctor() {
      if (!this.history.doctor) return "";
      return this.history.doctor.user.name;
    },
    summary() {
      let tmp = document.createElement("DIV");
      tmp.innerHTML = this.history.notes;
      let notes = tmp.textContent || tmp.innerText || "";

      let ret = notes;
      return ret;
    },
    treatments_summary() {
      let ret = "";

      if (this.history.treatments && this.history.treatments.length > 0) {
        this.history.treatments.forEach((treatment) => {
          let teeth = "";
          if (treatment.teeth && treatment.teeth.length > 0) {
            teeth = " (" + treatment.teeth.join(",") + ") ";
          }
          ret += treatment.product.name + teeth;
        });
      }
      return ret;
    },
    ...mapGetters(['is_core'])
  },
  methods: {},
};
</script>

<style lang="scss">
.odontogram-history-entry {
  cursor: pointer;
  padding: 9px;
  background-color: var(--theme-grey-bg);
  border-bottom: 1px var(--theme-grey) solid;
  margin-bottom: 7px;
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;

  &__info {
    font-size: 16px;
    line-height: 20px;
    color: var(--theme-text-color);
    flex: 0 0 275px;
  }

  &__date {
    font-size: 14px;
    font-weight: 500;
    color: var(--theme-line-color);
  }

  &__summary {
    font-size: 12px;
    font-weight: 500;
    height: 100%;
    color: var(--theme-text-color);
  }

  &__documents {
    flex-grow: 1;
  }

  &__document {
    padding: 0 5px;
    color: var(--theme-color);
    font-size: 12px;
    max-width: 100px;
    transition: .3s;

    i {
      font-size: 20px;
    }

    &:hover {
      color: var(--theme-color);
      opacity: 0.8;
      text-decoration: none;
    }
  }
}
</style>

